import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=eb807f6c&scoped=true"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=eb807f6c&prod&lang=css"
import style1 from "./Lista.vue?vue&type=style&index=1&id=eb807f6c&prod&scoped=true&lang=css"
import style2 from "./styles.scss?vue&type=style&index=2&id=eb807f6c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb807f6c",
  null
  
)

export default component.exports